/**
 * ErrorReporter — wrap window errors and unhandled rejections.
 *
 * The configurable `sink` is whatever the host app wants: console, fetch to
 * an endpoint, Sentry SDK, etc. Default is `console.error`.
 */
export class ErrorReporter {
  /**
   * @param {object} opts
   * @param {(report: {kind: string, message: string, stack?: string, meta?: object}) => void} [opts.sink]
   * @param {object} [opts.meta] - Static fields merged into every report.
   */
  constructor(opts = {}) {
    this.sink = opts.sink || ((report) => console.error('[platform-error]', report));
    this.meta = opts.meta || {};
    this._installed = false;
  }

  install() {
    if (this._installed) return;
    this._installed = true;

    window.addEventListener('error', (ev) => {
      this.report({
        kind: 'window-error',
        message: ev.message || String(ev.error),
        stack: ev.error && ev.error.stack
      });
    });

    window.addEventListener('unhandledrejection', (ev) => {
      const reason = ev.reason || {};
      this.report({
        kind: 'unhandled-rejection',
        message: reason.message || String(reason),
        stack: reason.stack
      });
    });
  }

  report(report) {
    try {
      this.sink(Object.assign({}, report, { meta: this.meta }));
    } catch (_) { /* never throw from inside the reporter */ }
  }
}
